import { useEffect, useState } from "react";
import { TYPE_SHEET_LABEL } from "components/muyeon/ActiveTypeSheet";

/**
 * ★ 2026-10-31 다른 유형에 새 소식이 오면 하단 MY 탭 위에 잠깐 둥둥 떠 있다 사라지는 말풍선.
 *  앱은 '길게 눌러 보세요'(앱 시트), 웹은 '두 번 눌러 보세요'(MY 화면에서 한 번 더 눌러 시트).
 *  같은 수로는 한 번만 — 유형별로 마지막에 알린 수를 기기에 두고, 늘었을 때만 다시 띄운다.
 */
const KEY = "muyeon.typeNewsBubble";
const SHOW_MS = 5000;

const readSeen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch { return {}; } };
const writeSeen = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* 저장 불가 */ } };

export default function TypeNewsBubble({ others, isNative, blocked }) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (blocked) return undefined;
    const seen = readSeen();
    const fresh = Object.entries(others || {}).find(([t, n]) => n > (Number(seen[t]) || 0));
    // 읽어서 줄어든 유형은 기준도 낮춘다(다음에 새로 오면 다시 알리게).
    const next = { ...seen };
    Object.keys(seen).forEach((t) => { next[t] = Math.min(Number(seen[t]) || 0, Number(others?.[t]) || 0); });
    if (!fresh) { writeSeen(next); return undefined; }
    const [type, n] = fresh;
    next[type] = n;
    writeSeen(next);
    const label = TYPE_SHEET_LABEL[type] || type;
    setText(`${label} 유형에 새 소식이 있어요 · ${isNative ? "길게 눌러 보세요" : "두 번 눌러 보세요"}`);
    return undefined;
  }, [others, isNative, blocked]);

  // 떠 있는 시간은 따로 잰다 — 숫자가 다시 와도(소켓) 사라지는 타이머가 끊기지 않게.
  useEffect(() => {
    if (!text) return undefined;
    const t = setTimeout(() => setText(""), SHOW_MS);
    return () => clearTimeout(t);
  }, [text]);

  if (!text) return null;
  return (
    <div className="type-news-bubble" role="status" aria-live="polite">
      {text}
    </div>
  );
}
